<template>
  <div>
    <div class="">
      <h2 class="text-center">{{ $t("transfer.records") }}</h2>
    </div>

    <!-- Begin: Pagination -->

    <div class="table-responsive mb-0" v-if="pagination && pagination.docs.length > 0">
      <table class="table table-centered table-nowrap  , table table-bordered table-striped">
        <tbody>
          <th class="text-center">{{ $t("sector.text") }}</th>
          <th class="text-center">{{ $t("transfer.level") }}</th>
          <th class="text-center">{{ $t("transfer.piece") }}</th>
          <th class="text-center">{{ $t("transfer.start-time") }}</th>
          <th class="text-center">{{ $t("transfer.end-time") }}</th>
          <tr v-for="item in pagination.docs" :key="item._id" class="hider">
            <td class="text-center">
              {{ item.sector.name.tr }}
            </td>
            <td class="text-center">
              {{ item.level.name.tr }}
            </td>
            <td class="text-center">{{ item.itemCount }}</td>
            <td class="text-center">{{ converTime(item.rangeDate[0]) }}</td>
            <td class="text-center">{{ converTime(item.rangeDate[1]) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <content-loading v-if="loading" />
    <empty v-if="!loading && (!pagination || pagination.docs.length == 0)">
      <h5 class="text-center" id="myText">
        {{ $t("common.not-found") }}
      </h5>
    </empty>

    <div v-if="pagination" class="row">
      <div class="col">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
        </ul>
      </div>
    </div>

    <!-- End: Pagination -->
  </div>
</template>

<script>
import { format } from "date-fns";
import { maxLength, minLength, required } from "vuelidate/lib/validators";
const state = "managementTransfer";

export default {
  data() {
    return {
      request: {
        options: { page: 1, limit: 10, sort: { "scope.workspace": "asc" } },
        query: {},
      },
      form: {},
      formError: undefined,
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(350),
      },
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        this.form = { ...this.prepareFormForEdit(v) };
      },
    },
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.init());
      },
    },
  },

  computed: {
    pagination() {
      return this.$store.getters[`${state}/pagination`];
    },
    loading() {
      return this.$store.getters[`${state}/isLoading`];
    },
    isUpdating() {
      return this.$store.getters[`${state}/isUpdating`];
    },
    editedEntity() {
      return this.$store.getters[`${state}/editedEntity`];
    },
    isEditMode() {
      return this.$store.getters[`${state}/isEditMode`];
    },
  },
  mounted() {
    this.$store.dispatch(`managementTransfer/paginate`, this.request);
  },
  methods: {
    converTime(time) {
      if (!time) {
        return undefined;
      }
      const date = new Date(time);
      return format(date, `dd-MM-yyyy`);
    },
    init() {
      this.$store.dispatch(`managementTransfer/paginate`, this.request);
    },
  },
};
</script>
